var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"component-footer"},[_c('div',{staticClass:"wrapper"},[_c('dl',{},[_c('dt',[_vm._v("联系我们")]),_c('openWeapp'),_c('dd',[_vm._v("客服电话：010-57347630")]),_c('dd',[_vm._v("微信公众号：秘邻圈")])],1)]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_c('p',[_vm._v("量子像素（北京）科技有限公司 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("京ICP备19037457号")])])])
}]

export { render, staticRenderFns }